import addToHomescreen from "add-to-homescreen/addtohomescreen";

export default () => {
    window.addToHomescreen();
};
